import { useEffect, useRef } from 'react'

/**
 * Calls `onVisible` when it scrolls into view (with some look-ahead). Pass a
 * changing `token` (e.g. the item count) so it asks again after each page
 * while it is still on screen.
 */
export function Sentinel({ onVisible, token }: { onVisible: () => void; token: number }) {
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const io = new IntersectionObserver((entries) => entries.some((e) => e.isIntersecting) && onVisible(), {
      rootMargin: '0px 0px 160px 0px',
    })
    io.observe(el)
    return () => io.disconnect()
  }, [onVisible, token])
  return <div ref={ref} className="lib-sentinel" aria-hidden="true" />
}
